const APP_NAME = "Frøy Engage";

// Sidebar page names by path prefix. The pages carry no title of their own,
// so the browser tab names the page instead.
const SIDEBAR_PAGES: Array<[prefix: string, name: string]> = [
  ["/dashboard", "Oversikt"],
  ["/mission", "Turrapporter"],
  ["/vessels", "Fartøyskart"],
  ["/settings/webhooks", "Webhooks"],
];

export function getEnvPrefix(hostname: string): string {
  if (hostname === "localhost" || hostname === "127.0.0.1") return "[local] ";
  if (hostname.includes("staging")) return "[staging] ";
  const previewMatch = hostname.match(/^pr-(\d+)\./);
  if (previewMatch) return `[prev-${previewMatch[1]}] `;
  if (hostname.includes("dev")) return "[dev] ";
  return "";
}

/** "Frøy Engage · Turrapporter", or just "Frøy Engage" off the sidebar pages. */
export function pageTitle(pathname: string): string {
  const page = SIDEBAR_PAGES.find(([prefix]) => pathname === prefix || pathname.startsWith(`${prefix}/`));
  return page ? `${APP_NAME} · ${page[1]}` : APP_NAME;
}
